import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import "./assets/app.css";

import VueScrollTo from  "vue-scrollto";
Vue.use(VueScrollTo, {
  container: "#container",
});

import inViewportDirective from "vue-in-viewport-directive";
Vue.config.productionTip = false;

import PortalVue from "portal-vue";
Vue.use(PortalVue);

import VueParallaxJs from "vue-parallax-js";
Vue.use(VueParallaxJs);

import VueSocialSharing from "vue-social-sharing";
Vue.use(VueSocialSharing);

import Vue2TouchEvents from "vue2-touch-events";

Vue.use(Vue2TouchEvents);

// import Axios from "axios";
// Vue.use(Axios);

// import PortalVue from "portal-vue";

Vue.directive("in-viewport", inViewportDirective);
inViewportDirective.defaults.margin = "-15% 10%";

import { longClickDirective } from "vue-long-click";

const longClickInstance = longClickDirective({ delay: 1500, interval: 250 });
Vue.directive("longclick", longClickInstance);


import VuejsDialog from "vuejs-dialog";
import VuejsDialogMixin from "vuejs-dialog/dist/vuejs-dialog-mixin.min.js"; // only needed in custom components
// inude the default style
import "vuejs-dialog/dist/vuejs-dialog.min.css";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);

import vOutsideEvents from "vue-outside-events";
Vue.use(vOutsideEvents);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");